"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SceneRenderer = require("./SceneRenderer");
Object.keys(_SceneRenderer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SceneRenderer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SceneRenderer[key];
    }
  });
});
var _ScaledSceneRenderer = require("./ScaledSceneRenderer");
Object.keys(_ScaledSceneRenderer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScaledSceneRenderer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScaledSceneRenderer[key];
    }
  });
});
var _ImageFileSource = require("./ImageFileSource");
Object.keys(_ImageFileSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ImageFileSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ImageFileSource[key];
    }
  });
});
var _ConnectedPresenterSource = require("./ConnectedPresenterSource");
Object.keys(_ConnectedPresenterSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConnectedPresenterSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ConnectedPresenterSource[key];
    }
  });
});
var _VideoFileSource = require("./VideoFileSource");
Object.keys(_VideoFileSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VideoFileSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VideoFileSource[key];
    }
  });
});
var _AudioFileSource = require("./AudioFileSource");
Object.keys(_AudioFileSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioFileSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioFileSource[key];
    }
  });
});